export default __webpack_public_path__ + "static/media/11.bbe0f0af.jpg";